import React from "react";

import { TableInContainerBlock as Value } from "@reactivated";

import { ContainerSizeSubBlock } from "../ContainerSizeSubBlock";
import { TableBlock } from "../TableBlock";

import styles from "./index.module.scss";

interface Props {
    value: Value;
}

export const TableInContainerBlock = (props: Props) => {
    if (!props.value.table) {
        return null;
    }
    return (
        <div className={styles.container}>
            <ContainerSizeSubBlock value={props.value.container}>
                <TableBlock value={props.value.table} />
            </ContainerSizeSubBlock>
        </div>
    );
};
